import { Avatar, NavLink } from "@mantine/core";
import React, { startTransition } from "react";
import { useUser } from "stores/useUser";
import css from "./Sidebar.module.scss";
import { MdOutlineWatchLater } from "react-icons/md";
import {
  BsFillPeopleFill,
  BsFillPersonFill,
} from "react-icons/bs";
import { TbBinaryTree2, TbSparkles } from "react-icons/tb";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
const Sidebar = () => {
  const { user } = useUser();
  const { pathname } = useLocation();
  const page = pathname.split("/");
  const navigate = useNavigate();
  const INSIGHTS = "/insights";

  // Helper function to navigate with startTransition
  const handleNavigate = (path) => {
    startTransition(() => {
      navigate(path);
    });
  };

  return (
    <div className={css.container}>
      <div className={css.profile}>
        <Avatar
          src={user.photoURL}
          alt="profile img"
          radius="xl"
          size={"70px"}
        />
        <span>{user.displayName}</span>
      </div>

      <div className={css.menuWrapper}>
        <NavLink
          icon={<TbBinaryTree2 size={16} />}
          className={css.item}
          label="My Organization"
          onClick={() => handleNavigate(`${INSIGHTS}/organization`)}
          active={page.includes("organization")}
        />
        <NavLink
          icon={<HiOutlineDocumentReport size={16} />}
          className={css.item}
          label="My Directs"
          active={page.includes("direct-reportees")}
          onClick={() => handleNavigate(`${INSIGHTS}/direct-reportees`)}
        />
        <NavLink
          className={css.item}
          label="My time"
          icon={<MdOutlineWatchLater size={16} />}
          active={
            page.includes("me-time") && page[page.length - 1] === "me-time"
          }
          onClick={() => handleNavigate(`${INSIGHTS}/me-time`)}
          defaultOpened
        >
          <NavLink
            className={css.item}
            active={page.includes("organizer")}
            onClick={() => handleNavigate(`${INSIGHTS}/me-time/organizer`)}
            label="As Organizer"
            icon={<BsFillPersonFill size={16} />}
          />
          <NavLink
            className={css.item}
            active={page.includes("attendee")}
            onClick={() => handleNavigate(`${INSIGHTS}/me-time/attendee`)}
            label="As Attendee"
            icon={<BsFillPeopleFill size={16} />}
          />
          {/* <NavLink
            className={css.item}
            active={page.includes("optimize-next-week")}
            onClick={() => handleNavigate(`${INSIGHTS}/me-time/optimize-next-week`)}
            label="Optimize Next Week"
            icon={<TbSparkles size={16} />}
          /> */}
        </NavLink>
        {/* <NavLink
          icon={<BsFillFileEarmarkTextFill size={16} />}
          className={css.item}
          label="Actions"
          active={page.includes("actions-insights")}
          onClick={() => navigate(`${INSIGHTS}/actions-insights`)}
        /> */}
      </div>
    </div>
  );
};

export default Sidebar;
